<template>
  <div>
    <!-- Header -->
    <div class="d-flex justify-space-between align-center mb-6">
      <div>
        <div
          style="
            font-size: 30px;
            font-weight: 800;
            color: #111827;
            letter-spacing: -0.5px;
            line-height: 1.2;
          "
        >
          Internship Track
        </div>
        <div class="mt-1" style="font-size: 14px; color: #6b7280">
          Manage DSS criteria for student-to-organization matching
        </div>
      </div>
      <div class="d-flex align-center ga-3">
        <v-autocomplete
          hide-details
          density="compact"
          v-model="batch"
          item-value="id"
          item-title="name"
          @update:modelValue="initialize"
          variant="outlined"
          rounded="lg"
          :items="batchList"
          style="max-width: 200px"
          prepend-inner-icon="mdi-calendar-outline"
        ></v-autocomplete>
        <v-btn
          color="#00A63E"
          variant="flat"
          class="text-white"
          @click="addnew"
          prepend-icon="mdi-plus"
          rounded="lg"
          size="large"
        >
          Add Criterion
        </v-btn>
      </div>
    </div>

    <!-- Stats row -->
    <v-row class="mb-5" style="gap: 0">
      <v-col cols="12" sm="4">
        <div
          class="dss-stat-card rounded-xl pa-4 d-flex align-center"
          style="gap: 14px"
        >
          <div
            class="dss-stat-icon rounded-lg pa-2"
            style="background: #dcfce7"
          >
            <v-icon color="#059669" size="22">mdi-format-list-checks</v-icon>
          </div>
          <div>
            <div
              style="
                font-size: 24px;
                font-weight: 800;
                color: #111827;
                line-height: 1;
              "
            >
              {{ data.length }}
            </div>
            <div
              style="
                font-size: 12.5px;
                font-weight: 600;
                color: #6b7280;
                margin-top: 2px;
              "
            >
              Total Criteria
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="4">
        <div
          class="dss-stat-card rounded-xl pa-4 d-flex align-center"
          style="gap: 14px"
        >
          <div
            class="dss-stat-icon rounded-lg pa-2"
            style="background: #ede9fe"
          >
            <v-icon color="#7c3aed" size="22">mdi-school-outline</v-icon>
          </div>
          <div>
            <div
              style="
                font-size: 24px;
                font-weight: 800;
                color: #111827;
                line-height: 1;
              "
            >
              {{ programsCovered }}
            </div>
            <div
              style="
                font-size: 12.5px;
                font-weight: 600;
                color: #6b7280;
                margin-top: 2px;
              "
            >
              Programs Covered
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="4">
        <div
          class="dss-stat-card rounded-xl pa-4 d-flex align-center"
          style="gap: 14px"
        >
          <div
            class="dss-stat-icon rounded-lg pa-2"
            style="background: #fef3c7"
          >
            <v-icon color="#d97706" size="22">mdi-filter-cog-outline</v-icon>
          </div>
          <div>
            <div
              style="
                font-size: 24px;
                font-weight: 800;
                color: #111827;
                line-height: 1;
              "
            >
              {{ batchList.length }}
            </div>
            <div
              style="
                font-size: 12.5px;
                font-weight: 600;
                color: #6b7280;
                margin-top: 2px;
              "
            >
              Available Batches
            </div>
          </div>
        </div>
      </v-col>
    </v-row>

    <!-- Table Card -->
    <v-card flat class="rounded-xl table-card">
      <!-- Table header with search -->
      <div class="d-flex align-center justify-space-between px-5 py-4">
        <div style="font-size: 14px; font-weight: 600; color: #374151">
          Criteria List
          <v-chip size="x-small" color="green" variant="tonal" class="ml-2">{{
            data.length
          }}</v-chip>
        </div>
        <v-text-field
          v-model="search"
          placeholder="Search criteria..."
          prepend-inner-icon="mdi-magnify"
          variant="outlined"
          density="compact"
          hide-details
          rounded="lg"
          style="max-width: 260px"
        />
      </div>
      <v-divider />
      <v-data-table
        :headers="headers"
        :items="data"
        :search="search"
        :loading="loading"
        hover
        class="rounded-xl"
      >
        <template v-slot:[`item.title`]="{ item }">
          <div class="py-2">
            <div style="font-size: 13.5px; font-weight: 600; color: #111827">
              {{ item.title }}
            </div>
          </div>
        </template>
        <template v-slot:[`item.description`]="{ item }">
          <div
            class="py-2"
            style="
              max-width: 320px;
              font-size: 13px;
              color: #6b7280;
              line-height: 1.5;
            "
          >
            {{ item.description }}
          </div>
        </template>
        <template v-slot:[`item.programs`]="{ item }">
          <div class="d-flex flex-wrap ga-1 py-2">
            <v-chip
              v-for="i in item.programs"
              :key="i.id"
              size="x-small"
              variant="tonal"
              color="green"
              >{{ i.abbr || i.name }}</v-chip
            >
          </div>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <div class="d-flex align-center ga-1 flex-nowrap">
            <v-btn
              size="small"
              color="#00A63E"
              variant="tonal"
              prepend-icon="mdi-pencil-outline"
              rounded="lg"
              @click="editItem(item)"
              >Edit</v-btn
            >
            <v-btn
              size="small"
              color="error"
              variant="tonal"
              prepend-icon="mdi-delete-outline"
              rounded="lg"
              @click="deleteItem(item)"
              >Delete</v-btn
            >
          </div>
        </template>

        <template #no-data>
          <div class="text-center py-10">
            <v-icon size="48" color="#d1d5db">mdi-format-list-checks</v-icon>
            <div
              class="mt-3"
              style="font-size: 15px; font-weight: 600; color: #374151"
            >
              No criteria yet
            </div>
            <div class="mt-1" style="font-size: 13px; color: #9ca3af">
              Add your first DSS criterion to start matching students to
              organizations.
            </div>
            <v-btn
              color="#00A63E"
              variant="flat"
              class="text-white mt-4"
              rounded="lg"
              prepend-icon="mdi-plus"
              @click="addnew"
              >Add Criterion</v-btn
            >
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- Dialogs -->
    <DSSCriterionDialog
      :data="itemData"
      :action="action"
      :programs="programs_for"
      :batch="batch"
    />

    <v-dialog v-model="dialogConfirmDelete" max-width="500">
      <v-card class="rounded-md elevation-10">
        <v-card-title class="text-h6">Confirm Deletion</v-card-title>
        <v-card-text class="text-body-1">
          Are you sure you want to delete this criteria? This action is
          irreversible!
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="dialogConfirmDelete = false"
            >Cancel</v-btn
          >
          <v-btn
            color="error"
            class="white--text"
            @click="confirmDelete()"
            :disabled="btnLoading"
            :loading="btnLoading"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    />
  </div>
</template>

<script>
import eventBus from "@/eventBus";
import DSSCriterionDialog from "../../components/Dialogs/Forms/DSSCriterionDialog.vue";
export default {
  components: {
    DSSCriterionDialog,
  },

  // props: {
  //   reloadTable: {
  //     type: Boolean,
  //     required: true,
  //   },
  // },
  data: () => ({
    search: "",
    headers: [
      { title: "Title", value: "title", align: "start" },
      { title: "Description", value: "description", align: "start" },
      // {
      //   title: "Criteria Optimization",
      //   value: "criteria_optimization",
      //   align: "start",
      // },
      { title: "Program/s", value: "programs", align: "start" },

      {
        title: "Actions",
        value: "actions",
        align: "center",
        sortable: false,
        width: 180,
      },
    ],
    data: [],
    activeTab: "",
    tab: null,
    tabList: [],
    programs_for: [],
    perPageChoices: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "250", value: 250 },
      { text: "500", value: 500 },
    ],
    totalCount: 0,
    deleteData: null,
    itemData: null,
    alerted: false,
    btnLoading: false,
    loading: false,
    options: {},
    action: null,
    paginationData: {},
    formdata: [],
    work_dates_menu: false,
    dialogConfirmDelete: false,
    batch: null,
    batchList: [],
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Deleted!",
      message: "",
      top: 10,
    },
  }),
  mounted() {
    this.getBatch();
    this.getProgramsHandled();
    this.initialize();
    eventBus.on("closeDSSCriterionDialog", () => {
      this.initialize();
    });
  },
  beforeUnmount() {
    eventBus.off("closeDSSCriterionDialog");
  },
  computed: {
    programsCovered() {
      const ids = new Set();
      if (Array.isArray(this.data)) {
        this.data.forEach((d) => d.programs?.forEach((p) => ids.add(p.id)));
      }
      return ids.size;
    },
  },
  methods: {
    pagination(data) {
      this.paginationData = data;
    },
    initialize() {
      this.deleteData = null;
      if (!this.batch) {
        this.data = [];
        this.loading = false;
        return;
      }
      this.loading = true;
      setTimeout(() => {
        this.axiosCall(
          "/dss-criteria/getByHandledPrograms/" + this.batch,
          "GET",
        ).then((res) => {
          if (res) {
            this.data = Array.isArray(res.data) ? res.data : [];
            this.loading = false;
          }
        });
      }, 100);
    },

    changeTab(tab) {
      this.activeTab = tab.abbr;
      this.tab = tab.program_id;
      this.initialize();
    },
    addnew() {
      this.itemData = [{ id: null }];
      this.action = "Add";
    },
    deleteItem(item) {
      console.log(item);
      //   this.alerted = true;
      this.dialogConfirmDelete = true;
      this.deleteData = item;
    },
    editItem(item) {
      this.itemData = item;
      this.action = "Update";
    },

    getBatch() {
      this.axiosCall("/program/getProgramsBatchByInstitute", "GET").then(
        (res) => {
          this.batch = res.data.length > 0 ? res.data[0].id : null;
          this.batchList = res.data;
        },
      );
    },

    getProgramsHandled() {
      this.axiosCall("/program/getProgramsHandled", "GET").then((res) => {
        if (res) {
          console.log("Prog", res.data);
          this.programs_for = res.data;
          this.activeTab = res.data[0].abbr;
          this.tabList = res.data;
          this.tab = res.data[0].program_id;
          console.log(this.tabList);
          this.initialize();
        }
      });
    },
    confirmDelete() {
      this.axiosCall(
        "/dss-criteria/delete/" + this.deleteData.id,
        "DELETE",
      ).then((res) => {
        if (res.data.status == 200) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.message = res.data.msg;
          this.fadeAwayMessage.header = "System Message";
          this.btnLoading = false;
          this.dialogConfirmDelete = false;
          this.initialize();
        } else {
          this.btnLoading = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.message = res.data.msg;
          this.fadeAwayMessage.header = "System Message";
        }
      });
    },
  },
};
</script>

<style scoped>
.table-card {
  border: 1px solid #d1d5db !important;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06) !important;
}
.dss-stat-card {
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.2s;
  background: #ffffff;
}
.dss-stat-card:hover {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
}
.dss-stat-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
</style>
